import { ref, uploadString, getDownloadURL } from 'firebase/storage';
import { auth, storage } from './firebase';
import { createRecordId } from './journal-metrics';

export async function prepareProfileImage(file) {
  if (!/^image\/(jpeg|png|webp|gif)$/.test(file.type) || file.size > 10 * 1024 * 1024) throw new Error('Choose a JPG, PNG, WebP or GIF under 10 MB.');
  const source = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = () => reject(new Error('This image could not be read.')); reader.readAsDataURL(file); });
  const image = new Image(); image.src = source; await image.decode();
  const canvas = document.createElement('canvas'); canvas.width = 512; canvas.height = 512;
  const side = Math.min(image.naturalWidth, image.naturalHeight);
  if (!side) throw new Error('Choose a valid image.');
  canvas.getContext('2d').drawImage(image, (image.naturalWidth - side) / 2, (image.naturalHeight - side) / 2, side, side, 0, 0, 512, 512);
  return canvas.toDataURL('image/jpeg', .9);
}
export async function uploadProfileImage(uid, source) {
  if (auth.currentUser?.uid !== uid) throw new Error('Your account changed. Reopen your profile to continue.');
  const target = ref(storage, `users/${uid}/meta/avatars/${createRecordId()}`);
  await uploadString(target, source, 'data_url');
  if (auth.currentUser?.uid !== uid) throw new Error('Your account changed. Reopen your profile to continue.');
  return getDownloadURL(target);
}
